/* eslint-disable prettier/prettier */
export enum TreatyEntityType {
  TREATY = 'treaty',
  BROKER = 'broker',
  CEDANT = 'cedant',
  SIGNATURE = 'signature',
  PROPORTIONAL_SECTION = 'proportionalSection',
  NON_PROPORTIONAL_SECTION = 'nonProportionalSection',
  LAYER = 'layer',
  INSTALLMENT = 'installment',
  REINSTATEMENT = 'reinstatement',
  ADJUSTMENT = 'adjustment',
}
